function routeEnabled(permissions, route) {
  if (!route) return true
  return permissions?.routes?.[route] === true
}

function invoiceServiceOf(user) {
  return user?.currentAccount?.settings?.invoice?.service ?? null
}

function menuEntryVisible(permissions, entry, invoiceService) {
  const services = entry?.showOnService
  if (Array.isArray(services) && services.length) {
    if (!invoiceService || !services.includes(invoiceService)) return false
  }
  return routeEnabled(permissions, entry?.permission)
}

function resourceEnabled(permissions, resource, action) {
  if (!resource || !action) return false
  return permissions?.resources?.[resource]?.[action] === true
}

class PermissionUtility {
  menu = {
    /**
     * Whether a sidebar entry is visible for the signed-in user.
     * Honors route permissions and optional `showOnService` (invoice provider).
     *
     * @param {{ routes: Record<string, boolean> }} permissions
     * @param {{ permission?: string, showOnService?: string[] }} entry
     * @param {string|null|undefined} invoiceService
     * @returns {boolean}
     */
    entryVisible(permissions, entry, invoiceService) {
      return menuEntryVisible(permissions, entry, invoiceService)
    },

    /**
     * Invoice integration on the active account (`settings.invoice.service`).
     *
     * @param {object|null|undefined} user
     * @returns {string|null}
     */
    invoiceService(user) {
      return invoiceServiceOf(user)
    },
  }

  route = {
    /**
     * Whether the user may reach a route. Missing or empty `route` is
     * treated as enabled.
     *
     * @param {{ routes: Record<string, boolean> }} permissions
     * @param {string} route
     * @returns {boolean}
     */
    enabled(permissions, route) {
      return routeEnabled(permissions, route)
    },
  }

  resource = {
    /**
     * Whether the user has `action` on `resource`. Returns `false` when
     * `resource` or `action` is missing.
     *
     * @param {{ resources: Record<string, Record<string, boolean>> }} permissions
     * @param {string} resource
     * @param {string} action
     * @returns {boolean}
     */
    enabled(permissions, resource, action) {
      return resourceEnabled(permissions, resource, action)
    },

    /**
     * Whether the user lacks `action` on `resource`.
     *
     * @param {{ resources: Record<string, Record<string, boolean>> }} permissions
     * @param {string} resource
     * @param {string} action
     * @returns {boolean}
     */
    disabled(permissions, resource, action) {
      return !resourceEnabled(permissions, resource, action)
    },
  }
}

export default new PermissionUtility()
